import { ReactNode, useCallback, useMemo, useState } from 'react';
import {
  LeaderboardContext,
  LeaderboardContextType,
  useLeaderboard,
} from './LeaderboardContext';
import {
  LeaderboardClock,
  LeaderboardTillAge,
  LeaderboardType,
} from '@features/landing/grandprix/typings';

type Props = {
  tillAgeParam?: LeaderboardTillAge;
  onTillAgeParamChange?: (value: LeaderboardTillAge) => void;

  clockParam?: LeaderboardClock;
  onClockParamChange?: (value: LeaderboardClock) => void;

  leaderboardTypeParam?: LeaderboardType;
  onLeaderboardTypeParamChange?: (value: LeaderboardType) => void;

  showModalParam?: boolean;
  onOpenModal?: () => void;
  onCloseModal?: () => void;

  children?: ReactNode;
};

export function LeaderboardProvider({
  tillAgeParam = '11',
  onTillAgeParamChange,
  clockParam = 'blitz',
  onClockParamChange,
  leaderboardTypeParam = 'open',
  onLeaderboardTypeParamChange,
  showModalParam = false,
  onOpenModal,
  onCloseModal,
  children,
}: Props) {
  // Используем дефолтное значение контекста
  const leaderboard = useLeaderboard();

  //

  const [tillAge, setTillAgeState] = useState<LeaderboardTillAge>(tillAgeParam);
  const setTillAge = useCallback(
    (value: LeaderboardTillAge) => {
      setTillAgeState(value);
      onTillAgeParamChange?.(value);
    },
    [onTillAgeParamChange, setTillAgeState],
  );

  const [clock, setClockState] = useState<LeaderboardClock>(clockParam);
  const setClock = useCallback(
    (value: LeaderboardClock) => {
      setClockState(value);
      onClockParamChange?.(value);
    },
    [onClockParamChange, setClockState],
  );

  const [leaderboardType, setLeaderboardTypeState] =
    useState<LeaderboardType>(leaderboardTypeParam);
  const setLeaderboardType = useCallback(
    (value: LeaderboardType) => {
      setLeaderboardTypeState(value);
      onLeaderboardTypeParamChange?.(value);
    },
    [onLeaderboardTypeParamChange, setLeaderboardTypeState],
  );

  //

  const [showModal, setShowModal] = useState(showModalParam);

  const openModal = useCallback(() => {
    setShowModal(true);
    onOpenModal?.();
  }, [onOpenModal, setShowModal]);

  const closeModal = useCallback(() => {
    setShowModal(false);
    onCloseModal?.();
  }, [onCloseModal, setShowModal]);

  //

  const value: LeaderboardContextType = useMemo(
    () => ({
      tillAgeTabs: leaderboard.tillAgeTabs,
      clockTabs: leaderboard.clockTabs,
      leaderboardTypeTabs: leaderboard.leaderboardTypeTabs,
      tillAge,
      setTillAge,
      clock,
      setClock,
      leaderboardType,
      setLeaderboardType,
      showModal,
      openModal,
      closeModal,
    }),
    [
      leaderboard,
      tillAge,
      setTillAge,
      clock,
      setClock,
      leaderboardType,
      setLeaderboardType,
      showModal,
      openModal,
      closeModal,
    ],
  );

  return (
    <LeaderboardContext.Provider value={value}>
      {children}
    </LeaderboardContext.Provider>
  );
}
